export default class BeneficiarioAvaliacao {
    constructor(model = null){
        this.id = 0;
        this.empresaId = 0;
        this.beneficiarioId = 0;
        this.beneficiario = null;
        this.avaliacaoModeloId = 0;
        this.avaliacaoModelo = null;
        this.projetoId = null;
        this.projeto = null;
        this.usuarioId = 0;
        this.usuario = null;
        this.dataAvaliacao = new Date().yyyymmdd();
        this.media = 0;
        this.observacao = '';
        this.itens = [];

        if (!model)
            return;

        this.id = model.id ? model.id : 0;
        this.empresaId = model.empresaId ? model.empresaId : 0;
        this.beneficiarioId = model.beneficiarioId ? model.beneficiarioId : 0;
        this.beneficiario = model.beneficiario;
        this.avaliacaoModeloId = model.avaliacaoModeloId ? model.avaliacaoModeloId : 0;
        this.avaliacaoModelo = model.avaliacaoModelo;
        this.projetoId = model.projetoId ? model.projetoId : null;
        this.projeto = model.projeto;
        this.usuarioId = model.usuarioId ? model.usuarioId : 0;
        this.usuario = model.usuario;
        this.dataAvaliacao = model.dataAvaliacao ? new Date(model.dataAvaliacao).yyyymmdd() : new Date().yyyymmdd();
        this.media = model.media ? model.media : 0;
        this.observacao = model.observacao;
        this.itens = model.itens ? model.itens : [];

        if (model.createdAt)
            this.createdAt = model.createdAt;
        if (model.updatedAt)
            this.updatedAt = model.updatedAt;
    }
}
